export const actionTypes = {
  UPDATE_ADDITIONAL_INFO_LOADING: 'UPDATE_ADDITIONAL_INFO_LOADING',
  UPDATE_ADDITIONAL_INFO_RESULT: 'UPDATE_ADDITIONAL_INFO_RESULT',
  FETCH_ADDITIONAL_INFO_LOADING: 'FETCH_ADDITIONAL_INFO_LOADING',
  FETCH_ADDITIONAL_INFO: 'FETCH_ADDITIONAL_INFO',
};
